/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import { RECEIVED_ACCOUNTS } from './AccountBalancesActions';

export const hiddenAccountsReducer = (state = [], action) => {
  if (action.type === RECEIVED_ACCOUNTS) {
    return action.accounts.filter((account) => account.hiddenAccount);
  }
  return state;
};
hiddenAccountsReducer.priority = 17;
